/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const DiscountType = {
  VariableAmount: "VARIABLE_AMOUNT",
  VariablePercent: "VARIABLE_PERCENT",
  Variable: "VARIABLE",
  FixedAmount: "FIXED_AMOUNT",
  FixedPercent: "FIXED_PERCENT",
} as const;

export type DiscountType = (typeof DiscountType)[keyof typeof DiscountType];

export type DiscountTypeEnumType = typeof DiscountType;
export type DiscountTypeOptional = DiscountType;
export type DiscountTypeTrackedI = DiscountType;
export type DiscountTypeTracked = DiscountType;
export type DiscountTypeMetaI = EnumMetaType<
  DiscountTypeEnumType,
  DiscountType
>;
export const DiscountTypeMeta = typeMetaEnum<
  DiscountTypeEnumType,
  DiscountType
>("DiscountType", DiscountType);
export function transformDatesDiscountType(model: DiscountType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
